import React, { useState, useEffect } from 'react';

import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ZENDESK_KEY = "d27f8e11-4fbf-48b3-8e4e-690fcaeedc94"

const settings = {
  color: {
    theme: "#27292b"
  },
  webWidget: {
   authenticate: {
     chat: {
       jwtFn: function(callback) {
         fetch('/help/token').then(function(res) {
            res.text().then(function(jwt) {
             console.log("jwt");
             console.log(jwt);
             callback(jwt);
            });
          });
        }
      }
    },
    chat: {
      connectOnPageLoad: false
    },
    launcher: {
      badge: {
        layout: 'image_only'
      },
    },
    offset: { horizontal: '5px', vertical: '30px' }
  }
};

function HelpButton(props) {

  const [disabled, setDisabled] = useState(true);

  const open = () => {
    window.zE.showIPMWidget();
  }

  useEffect(() => {
    const script = document.createElement('script');

    script.id = "ze-snippet";
    script.src = "https://static.zdassets.com/ekr/snippet.js?key=" + ZENDESK_KEY;
    script.async = true;

    script.addEventListener('load', () => {
      window.zE('webWidget', 'hide');
      setDisabled(false);
    });

    document.body.appendChild(script);
    window.zESettings = settings;

    return () => {
      document.body.removeChild(script);
    }
  }, []);

  return (
  <Button variant="outline-secondary"
          onClick={open}
          disabled={disabled}>
    <FontAwesomeIcon icon="question" />
  </Button>
  );
}

export default HelpButton;
